import { jsxs as L, jsx as C } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ L(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
          fill: "#F3F3FD"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M43.9896 39.4132L44.0016 39.4012C48.5365 34.8663 55.9608 34.8663 60.4957 39.4012L62.5817 41.4872H72.5006V58.3311H64.8749L65.3029 58.759L60.5478 61.1042L50.571 66.0019L49.2624 66.6368C47.7853 67.3624 46.0102 67.0644 44.8441 65.8983L37.6919 58.7461H28.5723V41.9022H36.4092L36.7331 41.5783C38.7041 39.6073 41.4507 38.8856 43.9896 39.4132Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M22 36.4297H27.6429C28.7474 36.4297 29.6429 37.3251 29.6429 38.4297V60.144C29.6429 61.2485 28.7474 62.144 27.6429 62.144H22C20.8954 62.144 20 61.2485 20 60.144V38.4297C20 37.3251 20.8954 36.4297 22 36.4297Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M72.3574 36.4297H78.0003C79.1048 36.4297 80.0003 37.3251 80.0003 38.4297V60.144C80.0003 61.2485 79.1048 62.144 78.0003 62.144H72.3574C71.2529 62.144 70.3574 61.2485 70.3574 60.144V38.4297C70.3574 37.3251 71.2529 36.4297 72.3574 36.4297Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.3574 59.3311H66.1234C66.0281 59.4676 65.899 59.5802 65.7454 59.6559L55.8709 64.5154L51.0117 66.8997L51.0077 66.9016L49.7035 67.5343L49.2626 66.6368L49.6991 67.5365L49.701 67.5355C47.8383 68.4493 45.6036 68.0717 44.1372 66.6054L37.2779 59.7461H29.6431V57.7461H37.6922C37.9574 57.7461 38.2117 57.8514 38.3993 58.039L45.5514 65.1911C46.4167 66.0564 47.7307 66.2751 48.8217 65.7392L48.8261 65.7371L49.019 65.6435L46.2623 62.8868C45.8718 62.4963 45.8718 61.8631 46.2623 61.4726C46.6529 61.0821 47.286 61.0821 47.6766 61.4726L50.553 64.349C50.6755 64.4715 50.7596 64.6179 50.8052 64.7732L53.4292 63.4857L49.798 59.8546C49.4075 59.464 49.4075 58.8309 49.798 58.4404C50.1885 58.0498 50.8217 58.0498 51.2122 58.4404L55.0733 62.3015C55.1572 62.3853 55.223 62.4803 55.2708 62.5817L58.0344 61.2221L54.3197 57.495C53.9299 57.1038 53.9309 56.4706 54.3221 56.0808C54.7133 55.6909 55.3465 55.692 55.7363 56.0831L59.5845 59.9443C59.6992 60.0594 59.7801 60.1955 59.8272 60.3401L63.4612 58.5523L50.3513 45.4662L44.709 51.1086C42.1546 53.6629 38.0102 53.6629 35.4559 51.1086L33.8751 49.5279C33.6876 49.3403 33.5822 49.086 33.5822 48.8208C33.5822 48.5556 33.6876 48.3012 33.8751 48.1137L41.7124 40.2764C40.1535 40.4219 38.6343 41.0916 37.4405 42.2854L37.1165 42.6093C36.929 42.7969 36.6747 42.9022 36.4094 42.9022H29.6431V40.8978L36.0262 40.8712C38.1079 38.7896 40.9582 37.9459 43.6629 38.3403C48.6137 33.7716 56.3984 33.8895 61.203 38.6941L62.9961 40.4872H70.3574V38.4297C70.3574 37.3251 71.2529 36.4297 72.3574 36.4297H78.0003C79.1048 36.4297 80.0003 37.3251 80.0003 38.4297V60.144C80.0003 61.2485 79.1048 62.144 78.0003 62.144H72.3574C71.2529 62.144 70.3574 61.2485 70.3574 60.144V59.3311ZM44.709 40.1083C48.8533 35.9639 55.6444 35.9639 59.7888 40.1083L64.3496 44.6691C64.7401 45.0596 65.3732 45.0596 65.7638 44.6691C66.1543 44.2785 66.1543 43.6454 65.7638 43.2549L64.9961 42.4872H70.3574V57.3311H65.0687L51.0571 43.3449C50.6665 42.955 50.0339 42.9553 49.6436 43.3456L43.2947 49.6944C41.5215 51.4677 38.6433 51.4677 36.8701 49.6944L35.9965 48.8208L44.709 40.1083ZM78.0003 38.4297H72.3574V60.144L78.0003 60.144V38.4297Z",
          fill: "var(--plac-primary-gray)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 36.4297H27.6429C28.7474 36.4297 29.6429 37.3251 29.6429 38.4297V60.144C29.6429 61.2485 28.7474 62.144 27.6429 62.144H22C20.8954 62.144 20 61.2485 20 60.144V38.4297C20 37.3251 20.8954 36.4297 22 36.4297ZM27.6429 38.4297H22V60.144L27.6429 60.144L27.6429 38.4297Z",
          fill: "var(--plac-primary-gray)"
        }
      )
    ]
  }
);
export {
  e as GetDemoIllustration
};
//# sourceMappingURL=index.es478.js.map
